import { render } from "./ClientDetailsCard.vue?vue&type=template&id=136f289b"
import script from "./ClientDetailsCard.vue?vue&type=script&lang=js"
export * from "./ClientDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__